import moment from 'moment'
import 'moment/min/locales'
import _ from 'lodash/fp'

// set global moment locale
const locale = window.navigator.userLanguage || window.navigator.language
moment.locale(locale)

export const ENVIRONMENT = process.env.REACT_APP_ENV || 'staging'
export const isProduction = ENVIRONMENT === 'production'
const isHostedDev = ENVIRONMENT === 'dev' && process.env.REACT_APP_HOSTED_DEV === 'true'
const isStaging = ENVIRONMENT === 'staging'
export const PATH_API_BASE = isHostedDev
  ? 'https://api.dev.glfr.com'
  : isProduction ? 'https://api.glfr.com' : isStaging ? 'https://api.staging.glfr.com' : 'https://api.staging.glfr.com'
export const OAUTH_PATH = (unionId) => `${PATH_API_BASE}/oauth/${unionId}`

export const PATH_SHOPIFY_GRAPHQL = 'https://glfr-offers.myshopify.com/api/graphql'
export const SHOPIFY_TOKEN = 'e0f9126276b393bdec39658640d4af30'

const S3_BASE = 'https://s3-eu-west-1.amazonaws.com'

// club image: https://s3-eu-west-1.amazonaws.com/ingo-staging/images/clubs/web/${img_name}

const PATH_GRAPHQL = () => {
  switch (ENVIRONMENT) {
    case 'dev':
      return '127.0.0.1:8080'
    case 'staging':
      return 'be.staging.glfr.com'
    case 'production':
      return 'be.glfr.com'
    default:
      return 'be.glfr.com'
  }
}

export const PATH_GRAPHQL_HTTP = isHostedDev
  ? 'https://be.dev.glfr.com'
  : isStaging ? 'https://be.staging.glfr.com' : ENVIRONMENT === 'dev' ? `http://${PATH_GRAPHQL()}` : `https://${PATH_GRAPHQL()}`


const PATH_RETURN_PATH = () => {
  switch (ENVIRONMENT) {
    case 'dev':
      return 'localhost:3000'
    case 'staging':
      return 'my.staging.glfr.com'
    case 'production':
      return 'my.glfr.com'
  }
}

export const RETURN_PATH = isHostedDev
  ? 'https://my.dev.glfr.com'
  : ENVIRONMENT === 'dev' ? `http://${PATH_RETURN_PATH()}` : `https://${PATH_RETURN_PATH()}`

const findS3Bucket = () => {
  if (isHostedDev) {
    return 'ingo-dev'
  }
  switch (ENVIRONMENT) {
    case 'dev':
      return 'ingo-staging'
    case 'staging':
      return 'ingo-staging'
    case 'production':
      return 'ingo-prod'
    default:
      return 'ingo-prod'
  }
}
export const S3_BUCKET = findS3Bucket()
export const S3_PATH = S3_BASE + '/' + S3_BUCKET + '/'
export const S3_GUIDE_PATH = S3_PATH + 'course-guides/albatross-3/'
export const S3_CLUB_IMAGE_PATH = S3_PATH + 'images/clubs/web/'
export const S3_CLUB_IMAGE_PATH_SMALL = S3_PATH + 'images/clubs/card/'

export const getHoleImage = ({ guideId, holeId }) => `${S3_GUIDE_PATH}${guideId}/${holeId}.jpeg`
export const getClubImage = (fileName) => `${S3_CLUB_IMAGE_PATH}${fileName}`
export const getClubImageSmall = (fileName) => `${S3_CLUB_IMAGE_PATH_SMALL}${fileName}`
export const getGuideJsonUrl = (guideId) => `${S3_GUIDE_PATH}${guideId}/guide.json`
export const getClubLogo = (clubId) => `${S3_PATH}clubs/round/${clubId}_logo.png`

export const getUserProfilePicture = (profile) =>
  getPicture(`${_.get('profile_filename', profile) || _.get('profileFilename', profile)}`)

export const getPicture = (filename, updatedAt) => {
  if (!filename) {
    return ''
  }
  return `${S3_PATH}glfr/pictures/${filename}`
}

export const getStaticBackground = () => {
  if (isHostedDev) {
    return 'https://my.dev.glfr.com/static/media/banner-default.jpg'
  }
  if (isProduction) {
    return 'https://my.glfr.com/static/media/banner-default.jpg'
  }
  return 'https://my.staging.glfr.com/static/media/banner-default.jpg'
}
// eslint-disable-next-line
export const isMobile = (function (a, b) { return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) })(navigator.userAgent || navigator.vendor || window.opera)
